// modalStore.ts
import { create } from "zustand";

interface ModalState {
  isLoginOpen: boolean;
  tab: "login" | "register";
  openLogin: (tab?: "login" | "register") => void;
  closeLogin: () => void;
  setTab: (tab: "login" | "register") => void;
}

export const useModalStore = create<ModalState>((set) => ({
  isLoginOpen: false,
  tab: "login",
  openLogin: (tab = "login") => set({ isLoginOpen: true, tab }),
  closeLogin: () => set({ isLoginOpen: false }),
  setTab: (tab) => set({ tab }),
}));
